module.exports = __webpack_public_path__ + "static/shopify_website_consent_screen-0d85880c2457dd58643204673537f652.png";